import { render, staticRenderFns } from "./ebook.vue?vue&type=template&id=0971b3c1&scoped=true"
import script from "./ebook.vue?vue&type=script&lang=js"
export * from "./ebook.vue?vue&type=script&lang=js"
import style0 from "./ebook.vue?vue&type=style&index=0&id=0971b3c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0971b3c1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainButton: require('/app/components/main/buttons/MainButton.vue').default})
